import * as enquire from 'enquire.js';
import * as balanceText from 'Lib/balanceText.js';

/**
 * STANDALONE HERO MODULE CODE - FOR USE SPECIFICALLY WHEN THERE IS A VIDEO ASSOCIATED WITH THE HERO IMAGE
 */
export namespace HeroImage {
	/**
	 * Function swaps out desktop src for mobile src at mobile
	 */
	let heroImageInit = () => {
		let videos = document.querySelectorAll('.js-desktop-video');
		videos.forEach((video:HTMLVideoElement) => {
			let mobileSrc = video.getAttribute('data-mobile-src');
			let desktopSrc = video.getAttribute('data-desktop-src')

			enquire.register("screen and (max-width:767px)", {
				match: () => {
					video.querySelector('source').setAttribute('src', mobileSrc);
					video.load();
				},
				unmatch: () => {
					video.querySelector('source').setAttribute('src', desktopSrc);
					video.load();
				},
			});
		});
	};

	/**
	 * Function checks for the existence of a video with a mobile src to verify whether we need to run the function or not
	 */
	let hasMobileVideo = () => {
		let videos = document.querySelectorAll('.js-desktop-video');
		let hasVideoWithMobileSrc = false;
		if(videos.length) {
			videos.forEach((video) => {
				if(video.getAttribute('data-mobile-src')) {
					hasVideoWithMobileSrc = true;
				}
			});
		}
		return hasVideoWithMobileSrc;
	};


	export const init = () => {
		if(hasMobileVideo) {
			heroImageInit();
		}
	}
}


/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', HeroImage.init);
} else {  // `DOMContentLoaded` has already fired
	HeroImage.init();
}
